import { createStore, useStore } from './store';

export interface Toast {
  id: number;
  kind: 'success' | 'error' | 'info';
  message: string;
}

const store = createStore<readonly Toast[]>([]);
let nextId = 1;

export function toast(kind: Toast['kind'], message: string, ttlMs = kind === 'error' ? 7000 : 3500): void {
  const id = nextId++;
  store.set([...store.get(), { id, kind, message }].slice(-4));
  setTimeout(() => dismissToast(id), ttlMs);
}

export function dismissToast(id: number): void {
  store.set(store.get().filter((t) => t.id !== id));
}

export const useToasts = (): readonly Toast[] => useStore(store);
